// extracted by mini-css-extract-plugin
module.exports = {"button":"_2gz_w-1VT4Uu","paper":"_4teLPHbV9jKe","modal":"_2EmfUbEvyBjH","title":"_2VB_fvJZ-yc5","controls":"_37v5xUKoBVsc","content":"_2TpQ379IKikx","close":"_394-5TLnPYdS"};